import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import { toast } from "react-toastify";
import useHttpHook from "../../../../Hooks/HttpHook";
import { AddAttendee } from "../../../../utils/ApiConstant";
import { getImageUrl } from "../../../../utils/Helper";
import { CartLanguage } from "../../../../utils/Languages";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { showErrorToast } from "../../../../utils/notify";

const AttendeeForm = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [file, setFile] = useState(null);
  const hiddenFileInput = useRef(null);
  const [dobError, setDobError] = useState("");
  const [dob, setDob] = useState("");

  useEffect(() => {
    if (error && toast.isActive(error) === false) {
      showErrorToast(error);
      if (error === "You are unAuthrised") {
        window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
      }
    }
  }, [error]);

  useEffect(() => {
    if (props.attendee) {
      reset({
        name: props.attendee.name || "",
        email: props.attendee.email || "",
        mobile: props.attendee.mobile || "",
      });
      setDob(props.attendee.dob || "");
    }
  }, [props.attendee, reset]);

  const photoPreview =
    file ? URL.createObjectURL(file) :
    props.attendee?.photo?.[0]?.path ? getImageUrl(props.attendee.photo[0].path) :
    null;

  const onSubmit = async (data) => {
    if (!file && !props.attendee) {
      if (!toast.isActive("Please upload a photo")) {
        toast.error("Please upload a photo");
      }
      return;
    }

    if (!dob) {
      if (!toast.isActive("Please enter DOB")) {
        toast.error("Please enter DOB");
      }
      return;
    }

    if (data.mobile.length > 13) {
      return toast.error("Please enter valid mobile number less than 13");
    }

    data.eventId = props.eventId;
    data.ticketId = props.id;
    data.dob = dob;

    const validDate = new Date(data.dob).getTime();
    if (moment().isBefore(validDate) || moment().isSame(validDate)) {
      setDobError("Date of Birth should be less than current date");
      setTimeout(() => setDobError(""), 3000);
      return;
    }

    if (file) {
      data.photo = [file];
    }
    if (props.attendee) {
      data.id = props.attendee._id;
    }
    if (props.attendee?.photo && !file) {
      data.photo = props.attendee.photo;
    }

    const cartData = await sendRequest(AddAttendee, {
      method: "post",
      contentType: "multipart/form-data",
      data,
      imgFieldArr: ["photo"],
    });

    if (cartData.status === 1) {
      props.getCartData();
      reset({ name: "", email: "", mobile: "" });
      setDob("");
      setFile(null);
      window.location.reload();
    }
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      {dobError && <p className="event-attendee-form-error">{dobError}</p>}
      <form className="event-attendee-form" onSubmit={handleSubmit(onSubmit)}>
        <button
          type="button"
          className="event-attendee-photo-btn"
          aria-label="Add attendee photo"
          onClick={() => hiddenFileInput.current?.click()}
        >
          {photoPreview ? (
            <img className="event-attendee-photo" src={photoPreview} alt="" />
          ) : (
            <i className="bi bi-person-plus" aria-hidden="true"></i>
          )}
        </button>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={(event) => {
            if (event.target.files?.[0]) {
              setFile(event.target.files[0]);
            }
          }}
          hidden
          accept="image/jpeg,image/png,image/jpg"
        />

        <input
          className="event-attendee-input"
          type="text"
          placeholder={CartLanguage.attendees.name}
          {...register("name", { required: true })}
        />

        <input
          className="event-attendee-input"
          type="email"
          placeholder={CartLanguage.attendees.email}
          {...register("email", { required: true })}
        />

        <input
          className="event-attendee-input event-attendee-date"
          type="date"
          aria-label={CartLanguage.attendees.dob}
          value={dob}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setDob(e.target.value)}
        />

        <input
          className="event-attendee-input"
          type="tel"
          placeholder={CartLanguage.attendees.mobile}
          {...register("mobile", { required: true })}
        />

        <button
          type="submit"
          className="event-attendee-save-btn"
          disabled={loading}
        >
          Save
        </button>
      </form>
    </MainComponentWrapper>
  );
};

export default AttendeeForm;
